import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

export function NotFoundPage() {
  return (
    <>
      <SEO
        title="Siden blev ikke fundet (404) | KELFAE LOFTER ApS"
        description="Siden du leder efter findes desværre ikke på KELFAE LOFTER ApS."
      />

      <section className="py-24 bg-white min-h-[70vh] flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-4 text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#7FDCA7]/20 border border-[#7FDCA7]/40 text-neutral-900 text-3xl font-extrabold shadow-sm font-serif-heading">
            404
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-neutral-900 font-serif-heading">
            Siden kunne ikke findes
          </h1>

          <p className="text-sm text-neutral-600 max-w-md mx-auto leading-relaxed">
            Den side du leder efter findes ikke, er blevet flyttet eller har skiftet adresse. Benyt venligst et af nedenstående links til at komme videre.
          </p>

          <div className="pt-4 flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="px-6 py-3.5 bg-[#7FDCA7] hover:bg-[#69C892] text-neutral-950 font-bold text-xs rounded-xl transition-all shadow-sm"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/produkter"
              className="px-6 py-3.5 bg-white border border-neutral-300 text-neutral-900 hover:bg-neutral-100 font-semibold text-xs rounded-xl transition-all"
            >
              Se alle produkter
            </Link>
            <Link
              to="/kontakt"
              className="px-6 py-3.5 bg-white border border-neutral-300 text-neutral-900 hover:bg-neutral-100 font-semibold text-xs rounded-xl transition-all"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
